<template>
    <b-modal id="transfer_form" ref="transfer_form"
             @hidden="resetForm" no-close-on-backdrop
             modal-class="modal-right modal-dialog-scrollable">

        <template v-slot:modal-title>
            Transfer Client
        </template>

        <b-form v-if="admission">
            <b-row class="mb-4">
                <b-colxx md="12">
                    <b-alert show variant="info">
                        Code: {{ admission.data.attributes.code }} <br>
                        Facility: {{ admission.data.attributes.facility }} <br>
                        Unit: {{ admission.data.attributes.unit }} <br>
                        Admission Date: {{ admission.data.attributes.move_in }} <br>
                        Client's Name: {{ admission.data.attributes.client }}
                    </b-alert>
                </b-colxx>
            </b-row>

            <b-row v-if="validationError">
                <b-colxx md="12">
                    <b-alert class="text-center" show variant="danger"
                             v-text="validationError"/>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Transfer date" class="has-float-label">
                        <template v-slot:label>
                            <span>Transfer date<sup><code>*</code></sup></span>
                        </template>

                        <v-date-picker
                            popover-visibility="focus" mode="single"
                            v-model="datepicker.transfer_date"
                            @input="'transfer_date' in errors ? delete errors.transfer_date : ''"
                            :input-props="{ class:'form-control' + ('transfer_date' in errors ? ' border-danger' : ''), placeholder: 'MM-DD-YYYY' }"/>

                        <b-form-invalid-feedback :state="!'transfer_date' in errors"
                                                 v-text="'transfer_date' in errors ? errors.transfer_date[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Transfer To" class="has-float-label">
                        <template v-slot:label>
                            <span>Transfer To <sup><code>*</code></sup></span>
                        </template>
                        <v-select @input="updateUnit" :options="units"
                                  :border-danger="'unit_id' in errors">
                            <template slot="no-options">
                                No vacant units found.
                            </template>
                        </v-select>
                        <b-form-invalid-feedback :state="!('unit_id' in errors)"
                                                 v-text="'unit_id' in errors ? errors.unit_id[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12" class="mb-4">
                    <b-form-group label="Notes" class="has-float-label">
                        <b-form-textarea v-model="form.notes" rows="6" placeholder="Notes"/>
                    </b-form-group>
                </b-colxx>
            </b-row>
        </b-form>
        <template slot="modal-footer">
            <b-button variant="outline-secondary" @click="hideModal('transfer_form')" v-text="'Cancel'"/>

            <state-button variant="primary" :click="submitTransfer">Submit</state-button>
        </template>
    </b-modal>
</template>

<script>
import moment from "moment";
import {mapGetters} from "vuex";
import StateButton from "../../../../../components/Common/StateButton";

export default {
    name: "TransferFormModal",

    components: {
        StateButton,
    },

    props: [
        'admission'
    ],

    data() {
        return {
            datepicker: {
                transfer_date: null,
                ref_date: null,
            },
            validationError: null,
        }
    },

    computed: {
        ...mapGetters({
            units: 'getSelectVacantUnits',
            errors: 'getAdmissionTransferErrors',
            form: 'getTransferFrom'
        })
    },

    watch: {
        'datepicker.transfer_date'(date) {
            if (moment(date).format('YYYY-MM-DD') === 'Invalid date') return this.form.transfer_date = null;
            this.form.transfer_date = moment(date).format('YYYY-MM-DD');
        },
    },

    mounted() {
        this.getFormData(this.admission.data.attributes.facility_id);
    },

    methods: {
        getFormData(facility_id) {
            this.$store.dispatch('fetchSelectVacantUnits', facility_id);
        },

        resetForm() {
            this.$store.commit('setTransferForm');

            this.validationError = null;

            this.$emit('closed');
        },

        updateUnit(field) {
            if (field) {
                this.form.unit_id = field.unit_id;
            } else {
                this.form.unit_id = '';
            }
            'unit_id' in this.errors ? delete this.errors.unit_id : '';
        },

        hideModal(refname) {
            this.$refs[refname].hide();
        },

        submitTransfer() {
            let payload = {
                admission_id: this.admission.admission_id,
                form: {...this.form},
            }

            return new Promise((success, fail) => {
                this.$store.dispatch('submitAdmissionTransfer', payload)
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('transferred-client');

                            this.resetForm();

                            this.$notify('success filled', 'Success!', 'Transferred client!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('transfer_form');
                        }, 2000);
                    })
                    .catch(error => {
                        if (error.response.data.error) {
                            this.validationError = error.response.data.error;
                        }
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },
    }
}
</script>

<style scoped>

</style>
